import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';

import { mediaFields } from '~api/utils/skuFields';
import { IOrderItems } from '~api/CartAPI/ICartApiSdk';

const _getConfigSize = (): string[] => {
    const { config } = diContainer.get(serviceNames.config);

    return !!config?.cartItemImage?.length ? config.cartItemImage : [];
};

const _reArrangePlaceholderImage = (a: string, b: string): number => {
    const swap = !!b && b.includes('placeholder') || !b;

    return swap ? -1 : 0;
};

export const getSkuMedia = (item: IOrderItems) => {
    const getMediaFields = {
        configSizes: _getConfigSize(),
        ...mediaFields
    };

    const [configMedia, largeMedia, mediumMedia, smallMedia] = Object.values(getMediaFields).map(
        (fields) =>
            fields.reduce((acc: string[], field: keyof IOrderItems) => {
                const media = item?.[field] || '';

                return Array.isArray(media) ? [...acc, ...media] : media ? [...acc, media] : acc;
            }, []) as string[]
    );

    const allMedia = [...configMedia, ...mediumMedia, ...largeMedia, ...smallMedia];
    const unSortedAltThumb = [...new Set(allMedia)];
    const altThumb = unSortedAltThumb.sort(_reArrangePlaceholderImage);
    const thumb = altThumb?.shift() || '';

    return { thumb, altThumb };
};
